export default __webpack_public_path__ + "56c4d6e0d9821a8724142bbf5dd76f7a.png";